var _g, _path, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgProductBox7(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 31,
    viewBox: "0 0 30 31",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2771_53769)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16.5 16.4L7.5 11.21",
    stroke: "#F7AD3C",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21 22.9999V14.9999C20.9996 14.6492 20.9071 14.3047 20.7315 14.0011C20.556 13.6974 20.3037 13.4453 20 13.2699L13 9.2699C12.696 9.09437 12.3511 9.00195 12 9.00195C11.6489 9.00195 11.304 9.09437 11 9.2699L4 13.2699C3.69626 13.4453 3.44398 13.6974 3.26846 14.0011C3.09294 14.3047 3.00036 14.6492 3 14.9999V22.9999C3.00036 23.3506 3.09294 23.6951 3.26846 23.9987C3.44398 24.3024 3.69626 24.5545 4 24.7299L11 28.7299C11.304 28.9054 11.6489 28.9979 12 28.9979C12.3511 28.9979 12.696 28.9054 13 28.7299L20 24.7299C20.3037 24.5545 20.556 24.3024 20.7315 23.9987C20.9071 23.6951 20.9996 23.3506 21 22.9999Z",
    stroke: "#F7AD3C",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.27002 13.96L12 19.01L20.73 13.96",
    stroke: "#F7AD3C",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12 29.08V19",
    stroke: "#F7AD3C",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.3335 7.99967H26.6668M22.0002 3.33301V12.6663V3.33301Z",
    stroke: "#F7AD3C",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2771_53769"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white",
    transform: "translate(0 7)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProductBox7);
export default __webpack_public_path__ + "static/media/product_box_7.95a1d852febb93807d22946b6ee1a60b.svg";
export { ForwardRef as ReactComponent };